export default "__VITE_ASSET__B0p2MjqP__"